/**
 * Generates a cryptographically random password with at least one uppercase,
 * one lowercase, one digit, and one symbol.
 */
export function generatePassword(length = 16) {
  const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const lower = 'abcdefghijklmnopqrstuvwxyz';
  const digits = '0123456789';
  const symbols = '!@#$%&*_+-=';
  const all = upper + lower + digits + symbols;

  const array = new Uint32Array(length);
  crypto.getRandomValues(array);

  // Guarantee at least one character from each category
  const password = [
    upper[array[0] % upper.length],
    lower[array[1] % lower.length],
    digits[array[2] % digits.length],
    symbols[array[3] % symbols.length],
  ];

  for (let i = password.length; i < length; i++) {
    password.push(all[array[i] % all.length]);
  }

  // Fisher-Yates shuffle
  for (let i = password.length - 1; i > 0; i--) {
    const j = array[i % array.length] % (i + 1);
    [password[i], password[j]] = [password[j], password[i]];
  }

  return password.join('');
}

/**
 * Generates a password and copies it to the clipboard.
 * Returns the generated password.
 */
export async function generateAndCopy(length = 16) {
  const password = generatePassword(length);
  try {
    await navigator.clipboard.writeText(password);
  } catch {
    // Clipboard API may not be available in all contexts
  }
  return password;
}
